export const announcements = (
  announcementCode: string,
  createAnnouncement = false
): string =>
  `/announcements/${announcementCode}${createAnnouncement ? "/views" : ""}`;
